export function INIT(state) {
	state.true;
}

export function SET_VEHICLES(state, vehicles) {
	state.vehicles = vehicles;
}

export function REMOVE_VEHICLE(state, { as24Id }) {
	const index = state.vehicles.findIndex(v => v.as24Id === as24Id);
	if (index < 0) return;
	state.vehicles.splice(index, 1);
}

export function INSERT_VEHICLE(state, vehicle) {
	const v = state.vehicles.find(v => v.as24Id === vehicle.as24Id);
	if (v) Object.assign(v, vehicle);
	else state.vehicles.push(vehicle);
}

export function UPDATE_VEHICLE(state, vehicle) {
	const v = state.vehicles.find(v => v.as24Id === vehicle.as24Id);
	if (v) Object.assign(v, vehicle);
	else state.vehicles.push(vehicle);
}

export function SET_HISTORY(state, history) {
	state.history = history;
}

export function SET_IMPORT_NOTIFICATION(state, importNotification) {
	state.importNotification = importNotification;
}

export function SET_IMPORT_PROGRESS(state, importProgress) {
	state.importProgress = importProgress;
}
